import Debug from 'debug';
import {LitElement, html, css} from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { extractTextFromScripts, waitWithLogging } from '../utils';
import { sqliteBroker } from '../services/SqliteBroker';
import { PdqSqliteStatement } from './pdq-sqlite-statement';
import { tableBroker } from '../services/TableBroker';
import { dataBroker } from '../services/DataBroker';
import { state } from 'lit/decorators';

const log = Debug('pdq:sqlite:query');
@customElement('pdq-sqlite-query')
export class PdqSqliteQuery extends PdqSqliteStatement  {

  _table: undefined|string;
  _sqliteTable: undefined|string;
  _datasource: undefined|string;
  @property({type: String}) get table(){return this._table}
  @property({type: String}) index: undefined|string;
  @property({type: String}) get datasource(){return this._datasource}
  @property({type: String, attribute: "sqlite-table"}) get sqliteTable(){return this._sqliteTable}


  set table(value: string | undefined) {
    this._table = value;
    this.refresh()
  }
  set datasource(value: string | undefined) {
    this._datasource = value;
    this.refresh()
  }
  set sqliteTable(value: string | undefined) {
    this._sqliteTable = value;
    this.refresh()
  }

  private query: string = '';
  private tableUpdatedUnsubscribe = () => {}

  render() {
    log('refresh')
    return html`
      <slot style="display: none" name="query" @slotchange="${this._onSlotChange}"></slot>
    `;
  }
  async refresh() {
    log('refresh');
    if (!this.query) {
      log(`query is not set, skipping...`)
      return
    }
    if (!this.database) {
      log(`WARNING: database is not set, query cannot be executed`)
      return
    }
    if (!this.table && !this.datasource) {
      log(`WARNING: both datasource and table are unset, no where to save the query results... skipping`)
      return
    }

    await waitWithLogging(log, sqliteBroker.getDatabaseReadyPromise(this.database),
      `Waiting for database[${this.database}] to be ready...`)

    const start = performance.now()
    const client = await sqliteBroker.getDatabaseClient(this.database, this.alias, `pdq:sqlite:query[${this.datasource}/${this.table}]`)
    log(`got client`)
    try {
      const data = await client?.query(this.query);
      log(`query "${this.query}" executed in ${performance.now() - start}ms found ${data.length} rows`)

      await dataBroker.setDataSource(this.datasource!, data)
      if (this.table) {
        await tableBroker.setTable(this.table, this.datasource!, this.index || '')
      }
    } catch (e) {
      log('query failed', e)
    }

    this.tableUpdatedUnsubscribe()
    this.tableUpdatedUnsubscribe = sqliteBroker.tableUpdated.subscribe(i => {
      if (i.database == this.database && i.table == this.sqliteTable) {
        log(`table ${this.table} updated... refreshing`)
        this.refresh()
      }
    }).unsubscribe
  }

  protected async _onSlotChange(event: Event){
    log('_onSlotChange')
    if (!this.database) {
      log(`WARNING: database is not set, query cannot be executed`)
      return
    }
    if (!this.table && !this.datasource) {
      log(`WARNING: both datasource and table are unset, no where to save the query results... skipping`)
      return
    }
    if (!this.datasource) {
      this.datasource = `${this.table}-ds`
      log(`using auto datasource name: "${this.datasource}"`)
    }

    try {
      log(`query setting...`)
      const slot = event.target as HTMLSlotElement;
      const nodes = slot.assignedNodes({ flatten: true });
      this.query = extractTextFromScripts(nodes);
      log(`query changed to ${this.query}`);
      this.refresh()
    } catch (e) {
      console.error(`Failed to parse statement`, e);
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.tableUpdatedUnsubscribe()
  }
}
